module.exports = __webpack_public_path__ + "static/media/weatherShowersScattered.380e219f.png";